<template>
	<div class>
		<ModalBox v-model="legacyModalVisible" size="sm" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none flex p-6">

			<div class="modal-container w-full">
				<Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mh-60"
					spinner-color="var(--c-dark-8)" spinner-size="15px" />
				<div v-else-if="allInOneStreams.length === 0">
					<div class="text-center px-3 mb-3 flex flex-wrap">
						<div class="w-full">
							<div class="flex justify-center">
						<icon-base class="mb-3" :width="40" :height="40" width-view-box="40" height-view-box="40" fill="none"><icon-empty-live-streams /></icon-base>
							</div>
							<h3 class="text-s-m mb-2 text-500">You don't have any livestreams</h3>
							<p class="text-s-s text-dark-9 mb-1 text-400">Please create a livestream</p>
						</div>
					</div>
					<div class="px-3 mt-3 flex flex-wrap">
						<div class="w-full">
							<div class="w-full sm:max-w-[300px] sm:ml-auto">
								<div class="text-center flex flex-col-reverse sm:flex-row items-stretch sm:items-center sm:justify-end gap-2 mt-3 create-highlight">
									<FormButton type="secondary" size="md" class="w-full justify-center" @click="closeModal">
										Cancel
									</FormButton>
									<FormButton type="main" size="md" to="/dashboard" class="w-full sm:w-auto justify-center mt-0">
										Go to Livestreams
									</FormButton>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="px-3 mb-3 flex flex-wrap">
						<div class="w-full">
							<h3 class="text-base font-medium text-white mb-1">New Live Clipping</h3>
							<p class="text-s-s text-dark-9 mb-1 text-400">Choose a stream and highlight a moment.</p>
						</div>
					</div>
					<div class="highlight-quota-exceeded flex flex-wrap" v-if="isAccessHighlight && (highlight.length >= isAccessHighlight)">
						<div class="flex algn-items-start justify-start w-full">
						<icon-base class="mr-2 mt-1 text-[#FAFAFB]" :width="24" :height="24" width-view-box="16" height-view-box="15"><icon-alert-triangle /></icon-base>
						<p class="text-s-ss mb-0 text-white mb-1 text-400">Maximum quota for Live Clipping has been reached.
								Please <span class="text-underline cursor-pointer" onclick="Intercom('show')">contact sales</span>.</p>
						</div>
					</div>
					<div class="px-3 mb-2 flex flex-wrap">
						<div class="w-full">
							<label class="text-dark-9 text-500 text-s-ss mb-2">
								Live clipping name
							</label>
							<FormInput v-model="highlightName" class="input" placeholder="Live clipping name" />
						</div>
					</div>
					<div class="px-3 flex flex-wrap">
						<div class="positiom-relative w-full">
							<label class="text-dark-9 text-s-ss text-500 mb-2">
								Streams
							</label>
							<drop-down-menu :disabled="hasLiveSubscription && !hasLiveSubscription.enabled" ref="source" right
								type="flat" size="md" id="stream-source-aio" listClasses="bg-dark-3" fullWidth>
								<template #toggle-button>
									<IconBase v-if="this.selectedAIO" class="mr-2 shrink-0">
										<IconCamera />
									</IconBase>
									<span class="min-w-0 flex-1 truncate text-left">
										{{ this.selectedAIO ? this.selectedAIO.name : 'Select a stream' }}
									</span>
									<IconBase class="ml-auto shrink-0">
										<IconChevronDown />
									</IconBase>
								</template>
								<template #menu-items>
									<!-- drop-down-menu-text never existed (mechanical b-dropdown-text rename); plain div -->
									<div class="px-0">
										<div v-if="allInOneStreams.length" class="">
											<div class="relative rounded flex items-center">
												<IconBase class="absolute z-10 left-2 text-dark-6 top-1/2 -translate-y-1/2">
													<IconSearch />
												</IconBase>
												<FormInput ref="searchWidgetInputElement" v-model="search" placeholder="Search for files"
													size="md" customClasses="!border-0 !bg-dark-5 !px-10" />
												<FormButton @click="search = ''" type="light" :isIcon="true" size="md" class="absolute right-2 top-1/2 -translate-y-1/2"
													:class="{ 'active': search.length > 0 }">
													<IconBase>
														<IconCross />
													</IconBase>
												</FormButton>
											</div>
										</div>
										<div>
											<div class="text-center text-s-s text-dark-7 mt-3 mb-1" v-if="allInOneStreams.length === 0">
												Please create a Live Stream.
											</div>
											<ul v-else class="stream-source-list mt-2">
												<li v-for="(item, index) in allInOneStreamsFiltered"
													:key="index" @click="setElement(item)"
													class="flex items-center text-dark-8 px-3 py-2 text-s-s flex-shrink-0 min-w-0">
													<icon-base class="mr-2 shrink-0"><icon-camera /></icon-base>
													<span class="block truncate dropdown-text min-w-0">{{ truncateName(item.name) }}</span>
													<span v-if="item.liveStatus" class="ml-2 live-badge shrink-0">live</span>
												</li>
											</ul>
										</div>
									</div>
								</template>
							</drop-down-menu>

							<div class="no-live-stream mt-3 flex flex-wrap" v-if="highlightLiveErr">
								<div class="flex algn-items-start justify-start w-full">
						<icon-base class="mr-2 mt-1 text-[#FAFAFB]" :width="60" :height="24" width-view-box="16" height-view-box="15"><icon-alert-triangle /></icon-base>
								<p class="text-s-ss mb-0 text-white mb-1 text-400">The selected livestream is not active. Proceeding
										will load an
										empty player. To display content, start streaming to the selected livestream.</p>
								</div>
							</div>
						</div>
					</div>
					<div class="px-3 mt-3 flex flex-wrap">
						<div class="w-full">
							<div class="w-full sm:max-w-[300px] sm:ml-auto">
								<div class="text-center flex flex-col-reverse sm:flex-row items-stretch sm:items-center sm:justify-end gap-2 mt-3 create-highlight">
									<FormButton type="secondary" size="md" class="w-full justify-center" @click="closeModal">
										Cancel
									</FormButton>
									<FormButton :disabled="(!this.highlightAllowed || !this.selectedAIO)" @click="onConfirm" type="main"
										size="md" class="w-full justify-center mt-0">
										Create Live Clipping
									</FormButton>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import _ from 'lodash'
import Spinner from "@/components/ui/Spinner.vue"
import { mapGetters } from 'vuex'
import HighlightService from '@/services/HighlightService'
import StreamStatsService from '@/services/StreamStatsService'
import FormButton from '@/components/Atoms/FormButton.vue';
import FormInput from '@/components/Atoms/FormInput.vue'
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import IconCamera from '../icon/IconCamera.vue'
import IconChevronDown from '../icon/IconChevronDown.vue'
import IconBase from '../icon/IconBase.vue'
import IconSearch from '../icon/IconSearch.vue'
import IconCross from '../icon/IconCross.vue'
import IconEmptyLiveStreams from '../icon/IconEmptyLiveStreams.vue'
import IconAlertTriangle from '../icon/IconAlertTriangle.vue'
import { track, EVENTS } from '@/lib/tracking'


export default {
	name: 'AddHighlightModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-highlight',
	components: {
		ModalBox,
		DropDownMenu,
		DropDownMenuItem,
		FormButton,
		FormInput,
		Spinner,
		IconCamera,
		IconChevronDown,
		IconBase,
		IconSearch,
		IconCross,
		IconEmptyLiveStreams,
		IconAlertTriangle,
	},
	data() {
		return {
			highlightName: '',
			error: null,
			exists: [],
			selectedAIO: null,
			search: '',
			highlightLiveErr: false,
			liveStatus: {},
		}
	},
	props: {
		highlight: {
			type: Array,
		},
	},
	computed: {
		...mapGetters({
			hasLiveSubscription: "User/hasLiveSubscription",
			allInOneStreams: "Streams/allInOneStreams",
			subscriptions: "User/subscriptions",
			loadingStatus: "Ui/loadingStatus",
		}),
		allInOneStreamsFiltered() {
			const allInOneStreams = _.cloneDeep(this.allInOneStreams.filter(stream => stream.name.toLowerCase().includes(this.search.toLowerCase())))
			return allInOneStreams.map(x => ({ ...x, liveStatus: this.liveStatus[x.key] })).sort(function (a, b) {
				return new Date(b.creationTime) - new Date(a.creationTime)
			})
		},
		highlightAllowed() {
			return (this.highlightName.length > 0) && this.isAccessHighlight && (this.highlight.length < this.isAccessHighlight)
		},
		isAccessHighlight() {
			let sub = null
			this.subscriptions.some((item) => {
				if (item.enabled && item.category === 'live') sub = item
			})
			let isValidPlanOverrideDefinition = null
			let isValidPlanDefinition = false
			if (sub) {
				if (sub?.package?.definition?.maxHighlightCount) isValidPlanDefinition = sub.package.definition.maxHighlightCount
				if (sub?.definitionOverride?.maxHighlightCount) isValidPlanOverrideDefinition = sub.definitionOverride.maxHighlightCount
			}
			if (isValidPlanOverrideDefinition) return isValidPlanOverrideDefinition
			return isValidPlanDefinition
		},
	},
	watch: {
		async allInOneStreams(newArr) {
			await Promise.all((newArr || []).map(async (a) => {
				this.liveStatus[a.key] = await this.checkIsAlive(a.key)
			}))
		}
	},
	async mounted() {
		this.highlightLiveErr = false
		await this.$store.dispatch('Streams/getStreams')
	},
	methods: {
		// was @hidden="onReset" on the old b-modal
		onLegacyModalHidden() {
			this.onReset();
		},
		async onConfirm() {
			try {
				this.$store.dispatch('Ui/setLoadingStatus', true)
				const newHighlight = await HighlightService.createHighlight(
					this.highlightName,
					'',
					this.selectedAIO._id
				)
				this.$emit('highlight-created', newHighlight)
				console.log(newHighlight)
				track(EVENTS.HIGHLIGHT_CREATED, { streamId: this.selectedAIO?._id })
				this.$notify({ group: 'success', text: 'Live clipping created.' })

				this.$store.dispatch('Ui/setLoadingStatus', false)
				await this.$store.dispatch('Highlight/getHighlight', true)

				this.closeModal()

				// }

			} catch (err) {
				this.error = err.message
				// this.$store.dispatch('Ui/setLoadingStatus', false)
			}
		},
		truncateName(name) {
			if (name.length >= 20) {
				return name.slice(0, 20) + '...'
			}
			return name
		},
		async checkIsAlive(key) {
			const mediaPulse = await StreamStatsService.getStreamMediaPulse(key)
			return mediaPulse?.alive
		},
		async setElement(item) {
			this.highlightLiveErr = false
			this.selectedAIO = item
			this.$refs.source?.hideDropDownMenu()
			if (item?.key) {
				try {
					const mediaPulse = await StreamStatsService.getStreamMediaPulse(item?.key)
					if (mediaPulse?.alive) {
						this.highlightLiveErr = false
					} else {
						this.highlightLiveErr = true
					}
				} catch (err) {
					console.log(err)
				}
			}
		},
		closeModal() {
			this.playlistName = ''
			this.selectedAIO = null
			this.highlightLiveErr = false
			this.highlightName = ''
			this.hideLegacyModal()
		},
		onReset() {
			this.error = null
		}
	}
}
</script>

<style scoped>
.live-badge {
	background-color: var(--c-dark-4);
	padding: 1px 4px;
	border-radius: 4px;

	color: #D1DBF0;
	font-weight: 500;
	font-size: var(--font-s-xs);
}

.dropdown-text {
	font-family: Inter;
	font-weight: 400;
	font-size: 13px;
}

.new_highlight_search {
	margin: 0px 4px 4px 4px;
}

.new_highlight_search div {
	background: #404B72;
}

.new_highlight_search input {
	background: #404B72 !important;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
	background-color: #4a5682;
	border-radius: 6px;
	color: #fff;
}

.selected-stream--name {
	position: absolute;
	left: 25px;
	top: 37px;
	z-index: 9;
	color: var(--c-text-9);
	pointer-events: none;
	display: flex;
	align-items: center;
}

.selected-stream--name.stream-selected {
	color: var(--c-text-2);
}

#stream-source-aio {
	height: 32px;
	background: #404B72;
	border-radius: 6px;
	box-shadow: 0px 0.5px 0px 0px rgba(255, 255, 255, 0.08) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.04), 0px 12px 16px 0px rgba(0, 0, 0, 0.06);
}

#modal-add-highlight___BV_modal_content_ input {
	height: 32px;
}

#modal-add-highlight___BV_modal_content_ input::placeholder {
	color: #8794B5;
	font-size: var(--font-s-ss);
}

.highlight-quota-exceeded {
	padding: 3px 3px;
	border-radius: 6px;
	background: var(--secondary-warning, #E2A052);
	width: calc(100% - 30px);
	margin: 0 auto;
	margin-bottom: 15px;
}

.no-live-stream {
	border-radius: 6px;
	background: var(--secondary-warning, #E2A052);
	width: 100%;
	margin: 0 auto;
	margin-bottom: 15px;
}

@media (max-width: 767px) {}
</style>
